export const LINKEDIN_ACTION_ICON_PATHS: string[] = [
  'socialmedia/like-icon-linkedin.svg',
  'socialmedia/comment-icon-linkedin.svg',
  'socialmedia/repost-icon-linkedin.svg',
  'socialmedia/send-icon-linkedin.svg',
];
export const LINKEDIN_REACTIONS_ICON_PATH = 'socialmedia/reactions-icon-linkedin.svg';
